import { USER_ROLES } from '~/constants/user_roles';

import { getMainRoleUser } from './getMainRoleUser';

export const isValidLoginRole = (accessToken: string) => {
  const mainRole = getMainRoleUser(accessToken);
  return [USER_ROLES.agency, USER_ROLES.brand, USER_ROLES.brandUser].includes(
    mainRole
  );
};
